import { render, staticRenderFns } from "./NovaPermissao.vue?vue&type=template&id=212a1bef&scoped=true"
import script from "./NovaPermissao.vue?vue&type=script&lang=js"
export * from "./NovaPermissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212a1bef",
  null
  
)

export default component.exports